import { IconButton, Box, keyframes } from "@mui/material";
import PlayArrow from "@mui/icons-material/PlayArrowRounded";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";

const Variant1 = (props) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    setIsAnimating(true);
    setTimeout(() => {
      window.open(`/pitch-reels${props?.item?.pipeline_status === "invited" ? "" : "/selected"}?st=` + props?.item?._id);
      setIsAnimating(false);
    }, 600);
  };

  return (
    <IconButton
      sx={{
        background: "rgba(0, 0, 0, 0.04)",
        position: 'relative',
        overflow: 'visible',
        '&::before': isAnimating ? {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          border: '2px solid',
          borderColor: props?.theme.palette.customColors.indigo600,
          transform: 'translate(-50%, -50%) scale(0)',
          animation: 'ripple 0.6s ease-out',
          '@keyframes ripple': {
            to: {
              transform: 'translate(-50%, -50%) scale(2.5)',
              opacity: 0
            }
          }
        } : {}
      }}
      onClick={handleClick}
    >
      <PlayArrow sx={{ color: props?.theme.palette.customColors.indigo600 }} />
    </IconButton>
  );
}

const Variant2 = ({ item, theme }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    setIsAnimating(true);
    setTimeout(() => {
      window.open(`/pitch-reels${item?.pipeline_status === "invited" ? "" : "/selected"}?st=` + item?._id);
      setIsAnimating(false);
    }, 500);
  };

  return (
    <IconButton
      sx={{
        background: "rgba(0, 0, 0, 0.04)",
        transform: isAnimating ? 'rotateY(360deg) scale(1.1)' : 'rotateY(0deg) scale(1)',
        transition: 'transform 0.5s ease-in-out'
      }}
      onClick={handleClick}
    >
      <PlayArrow sx={{ color: theme.palette.customColors.indigo600 }} />
    </IconButton>
  );
};

const Variant3 = ({ item, theme, statuses = [], onOpenReel }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setIsAnimating(true);
    const isInvited = statuses?.find(el => el?.status === "New")?.value === item?.investor_status_id
    setTimeout(() => {
      if (onOpenReel) {
        onOpenReel(item, isInvited);
      } else {
        navigate(`/pitch-reels${isInvited ? "" : "/selected"}?st=` + item?._id);
      }
      setIsAnimating(false);
    }, 1000);
  };

  return (
    <IconButton
      sx={{
        background: "rgba(0, 0, 0, 0.04)",
        // boxShadow: isAnimating ? `0 0 20px ${theme.palette.customColors.indigo600}` : 'none',
        animation: isAnimating ? 'bounce 1s ease-in-out 2' : 'none',
        '@keyframes bounce': {
          '0%, 100%': { transform: 'translateY(0)' },
          '25%': { transform: 'translateY(-10px)' },
          '50%': { transform: 'translateY(0)' },
          '75%': { transform: 'translateY(-5px)' }
        },
        transition: 'box-shadow 0.3s'
      }}
      onClick={handleClick}
    >
      <PlayArrow sx={{ color: theme.palette.customColors.indigo600 }} />
    </IconButton>
  );
};

const PitchReelButton_MagneticPull = ({ item, statuses = [], onOpenReel }) => {
  const theme = useTheme();

  return <Variant3 item={item} theme={theme} statuses={statuses} onOpenReel={onOpenReel} />

};


export default PitchReelButton_MagneticPull;
